import { GetCompetenciesDocument, GetCompetenciesQuery } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

type Return = GetCompetenciesQuery['competencies']['competencies'] | undefined

export const useCompetencies = (): [Return, boolean] => {
  const { data, loading } = useQuery(GetCompetenciesDocument)

  return [data?.competencies?.competencies, loading]
}
